import * as tslib_1 from "tslib";
import setIsSearching from './setIsSearching';
import datapoints from '../datapoints';
import { findPeople } from 'owa-recipient-common/lib/services/findPeople';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import getAndPopulateSuggestedContacts from 'owa-recipient-common/lib/actions/getAndPopulateSuggestedContacts';
import processFindPeopleResult from 'owa-recipient-common/lib/actions/processFindPeopleResult';
import { action } from 'satcheljs/lib/legacy';
var MAX_ENTRIES = 5;
export default action('findReadWriteRecipient', datapoints.MentionsFindPeople)(function findReadWriteRecipient(viewState, queryString, searchDirectory) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var datapoint;
        return tslib_1.__generator(this, function (_a) {
            viewState.queryString = queryString;
            if (!queryString) {
                datapoint = returnTopExecutingActionDatapoint();
                getAndPopulateSuggestedContacts(viewState.recipientsShown);
                setIsSearching(viewState, false /* isSearching */);
                datapoint.addCustomData({ zeroState: true.toString() });
                return [2 /*return*/, Promise.resolve()];
            }
            else {
                setIsSearching(viewState, true /* isSearching */);
                return [2 /*return*/, findPeople(queryString, searchDirectory).then(function (findPeopleResult) {
                        var datapoint = returnTopExecutingActionDatapoint();
                        setIsSearching(viewState, false /* isSearching */);
                        var sameQueryString = viewState.queryString.trim() == queryString;
                        if (sameQueryString) {
                            viewState.selectedRecipientIndex = 0;
                            viewState.hasSearchedDirectory = searchDirectory;
                            processFindPeopleResult(viewState.recipientsShown, findPeopleResult, MAX_ENTRIES);
                        }
                        datapoint.addCustomData({
                            zeroState: false.toString(),
                            sameQueryString: sameQueryString.toString(),
                            searchDirectory: searchDirectory.toString(),
                        });
                    })];
            }
            return [2 /*return*/];
        });
    });
});
//# sourceMappingURL=findReadWriteRecipient.js.map